// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1pJuI","large":"styles_large__1EIjV"};